//import "./Home.scss";
import "../../App.scss";
import "../../assets/css/libraries.css";
import "../../assets/css/style.css";
import "../../assets/images/logo/logo-light-small.png";

// New Added By Tapas
import "./HomeNew.scss";

import Navbar from "../../components/Navbar/Navbar.jsx";
import NavLogo from "../../assets/images/logo/NavLogo.png";
import NavLogoFooter from "../../assets/images/logo/NavLogoFooter.png";
// import  "../../assets/js/jquery-3.5.1.min.js";
// import jQuery from 'jquery'
// import  "../../assets/js/plugins.js";
// import  "../../assets/js/main.js";
import { Helmet } from "react-helmet";

function Home() {
  return (
    <div className="wrapper">
      <Helmet>
        <script src="/assets/js/jquery-3.5.1.min.js"></script>
      </Helmet>
      {/*  <div className="preloader">
      <div className="loading"><span></span><span></span><span></span><span></span></div>
    </div><!-- /.preloader  --> */}

      {/* <!-- =========================
        Header
    ===========================  --> */}
      <Navbar />
      {/* <!-- /.Header  --> */}

      {/* <!-- ============================
        Slider
    ==============================  --> */}
      <section className="slider">
        <div
          className="slick-carousel m-slides-0"
           data-slick='{"slidesToShow": 1, "arrows": true, autoplay: true, "dots": false, "speed": 700,"fade": true,"cssEase": "linear"}'
        >

          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/3_1.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                  <div className="slide__content">
                    {/*<h2 className="slide__title slide_title_cus">
                      <span>Health Data Exchange</span> and Interoperability Through NDHM Gateway
                    </h2>
                    <h2 className="slide__title slide_title_cus">
                      Discovery of Services, Specialists & Facilites Through <span>Unified Health Interface (UHI)</span>
                    </h2>
                    <h2 className="slide__title slide_title_cus">
                      Health Data Standardization Through Medical Codification to be <span>Future Ready</span>
                    </h2>*/}
                    {/*<p className="slide__desc" style={{ color: "rgb(195, 197, 219)" }}>
                      The health and well-being of our citizens by state-of-the-art health care solutions will always
                      remain our top priority
                    </p>*/}

                    {/*<div className="d-flex justify-content-center align-items-center mb-10 d-block d-md-none">
                      <div>
                        <img src="../../assets/images/sliders/abdm_logo.png" alt="Abdm Logo" style={{width:'85px'}} />
                      </div>
                    </div>*/}

                    <h2 className="slide__title" style={{ color: "rgb(255, 255, 255)" }}>Digitized Healthcare <span className="text-lowercase">is</span> Far More Reality Now </h2>
                    <p className="slide__desc" style={{ color: "rgb(255, 255, 255)" }}>
                      Healthcare Providers integrating to ABDM Gateways unlocking benefits of interoperability, Discovery of HCP services, Data Standardization
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      {/* <!-- feature item #1  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <img src="../../assets/images/icons/3_1_2.png" alt="slide img" />
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(195, 197, 219)" }}>
                          Health ID
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #2  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <img src="../../assets/images/icons/3_1_3.png" alt="slide img" />
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(195, 197, 219)" }}>
                          Professionals <br/>Registry
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #3  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <img src="../../assets/images/icons/3_1_4.png" alt="slide img" />
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(195, 197, 219)" }}>
                          Facility<br/>
                          Registry
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #4  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <img src="../../assets/images/icons/3_1_1.png" alt="slide img" />
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(195, 197, 219)" }}>
                          Health <br/>Record (PHR)
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                    </ul>
                    {/* <!-- /.features-list  --> */}
                  </div>
                </div>
                  {/*<div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 d-none d-md-block text-right">
                    <img src="../../assets/images/sliders/abdm_logo.png" alt="slide img" className="pl-60" />
                  </div>*/}
              </div>
            </div>
          </div>

          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/1.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <div className="slide__content">

                    <div className="d-flex justify-content-center align-items-center mb-10 d-block d-md-none">
                      <div>
                        <img src="../../assets/images/sliders/ehr_logo.png" alt="Ehr Logo" style={{width:'85%'}} />
                      </div>
                    </div>

                    <h2 className="slide__title">A Digital Community First Strategic Vision</h2>
                    <p className="slide__desc">
                      The health and well-being of our citizens by state-of-the-art healthcare eco-system and solutions
                      will always remain our top priority
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart"></i>
                        </div>
                        <h2 className="feature__title">Lab Tests</h2>
                      </li>
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-medicine"></i>
                        </div>
                        <h2 className="feature__title">Reports</h2>
                      </li>
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart2"></i>
                        </div>
                        <h2 className="feature__title">Appointments</h2>
                      </li>
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-blood-test"></i>
                        </div>
                        <h2 className="feature__title">Dashboard</h2>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 d-none d-md-block text-right">
                  <img src="../../assets/images/sliders/ehr_logo.png" alt="Ehr img" className="pl-60" />
                </div>
              </div>
            </div>
          </div>

          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/2.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <div className="slide__content">
                    <h2 className="slide__title" style={{ color: "rgba(145, 97, 10, 0.911)" }}>
                      Next generation Healthcare Delivery Platform
                    </h2>
                    <p className="slide__desc" style={{ color: "rgb(145, 97, 10, 0.911)" }}>
                      A Comprehensive Healthcare Delivery Platform improving Patient Experience through flexible,
                      digitally connected engagement model
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(145, 97, 10, 0.911)" }}>
                          Devices
                        </h2>
                      </li>
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-medicine"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(145, 97, 10, 0.911)" }}>
                          Careplans
                        </h2>
                      </li>
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart2"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(145, 97, 10, 0.911)" }}>
                          Healthcheck
                        </h2>
                      </li>
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-blood-test"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(145, 97, 10, 0.911)" }}>
                          Alternate Treatments
                        </h2>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- /.slide-item  --> */}
          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/1a.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <div className="slide__content">
                    <h2 className="slide__title" style={{ color: "rgb(103, 243, 231)" }}>
                      Unlimited Digital Disruptions in Healthcare
                    </h2>
                    <p className="slide__desc" style={{ color: "rgb(103, 243, 231)" }}>
                      Transformations and fusions of latest disruptions, innovations towards a constant journey from
                      'Sickcare' to 'Healthcare'
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      {/* <!-- feature item #1  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(103, 243, 231)" }}>
                          Prescriptions
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #2  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-medicine"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(103, 243, 231)" }}>
                          Trends
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #3  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart2"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(103, 243, 231)" }}>
                          Subscriptions
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #4  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-blood-test"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(103, 243, 231)" }}>
                          Recommendations
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                    </ul>
                    {/* <!-- /.features-list  --> */}
                  </div>
                  {/* <!-- /.slide-content  --> */}
                </div>
                {/* <!-- /.col-xl-7  --> */}
              </div>
              {/* <!-- /.row  --> */}
            </div>
            {/* <!-- /.container  --> */}
          </div>
          {/* <!-- /.slide-item  --> */}




          {/* <!-- /.slide-item  --> */}
          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/4.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <div className="slide__content">
                    <h2 className="slide__title" style={{ color: "rgb(192, 131, 62)" }}>
                      Personalized Treatments and Patient Care
                    </h2>
                    <p className="slide__desc" style={{ color: "rgb(192, 131, 62)" }}>
                      Pushing boundaries everytime to make Patient experience consistent, agile and personalized keeping
                      the Data Privacy and Security at it's core
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      {/* <!-- feature item #1  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(192, 131, 62)" }}>
                          Medications
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #2  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-medicine"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(192, 131, 62)" }}>
                          Orders
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #3  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart2"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(192, 131, 62)" }}>
                          Predictions
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #4  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-blood-test"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(192, 131, 62)" }}>
                          Medicare
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                    </ul>
                    {/* <!-- /.features-list  --> */}
                  </div>
                  {/* <!-- /.slide-content  --> */}
                </div>
                {/* <!-- /.col-xl-7  --> */}
              </div>
              {/* <!-- /.row  --> */}
            </div>
            {/* <!-- /.container  --> */}
          </div>
          {/* <!-- /.slide-item  --> */}
          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/5.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <div className="slide__content">
                    <h2 className="slide__title" style={{ color: "rgb(78, 80, 173)" }}>
                      Intelligent smart immutable Data platform
                    </h2>
                    <p className="slide__desc" style={{ color: "rgb(78, 80, 173)" }}>
                      Smart and Immutable Platform with affordable IoT devices, AI/ML helping in Diagnostics, Trends,
                      Predictions and Recommendations
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      {/* <!-- feature item #1  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(78, 80, 173)" }}>
                          Upload Records
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #2  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-medicine"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(78, 80, 173)" }}>
                          Manage Records
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #3  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart2"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(78, 80, 173)" }}>
                          Add Storage
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #4  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-blood-test"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(78, 80, 173)" }}>
                          Compress Records
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                    </ul>
                    {/* <!-- /.features-list  --> */}
                  </div>
                  {/* <!-- /.slide-content  --> */}
                </div>
                {/* <!-- /.col-xl-7  --> */}
              </div>
              {/* <!-- /.row  --> */}
            </div>
            {/* <!-- /.container  --> */}
          </div>
          {/* <!-- /.slide-item  --> */}
          <div className="slide-item align-v-h">
            <div className="bg-img">
              <img src="../../assets/images/sliders/6.jpg" alt="slide img" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                  <div className="slide__content">
                    <h2 className="slide__title" style={{ color: "rgb(175, 173, 164)" }}>
                      Seamless Remote care towards Ohana Experience
                    </h2>
                    <p className="slide__desc" style={{ color: "rgb(175, 173, 164)" }}>
                      Healthcare journey from disconnected silos to an inter-connected, Automated, orchestrated
                      processes to craft an Ohana Experience
                    </p>
                    <ul className="features-list list-unstyled mb-0 d-flex flex-wrap">
                      {/* <!-- feature item #1  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(175, 173, 164)" }}>
                          Transcripts
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #2  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-medicine"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(175, 173, 164)" }}>
                          Histories
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #3  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-heart2"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(175, 173, 164)" }}>
                          Treatments
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                      {/* <!-- feature item #4  --> */}
                      <li className="feature-item">
                        <div className="feature__icon">
                          <i className="icon-blood-test"></i>
                        </div>
                        <h2 className="feature__title" style={{ color: "rgb(175, 173, 164)" }}>
                          Trends
                        </h2>
                      </li>
                      {/* <!-- /.feature-item --> */}
                    </ul>
                    {/* <!-- /.features-list  --> */}
                  </div>
                  {/* <!-- /.slide-content  --> */}
                </div>
                {/* <!-- /.col-xl-7  --> */}
              </div>
              {/* <!-- /.row  --> */}
            </div>
            {/* <!-- /.container  --> */}
          </div>
          {/* <!-- /.slide-item  --> */}
        </div>
        {/* <!-- /.carousel  --> */}
      </section>
      {/* <!-- /.slider  --> */}

      {/* <!-- ============================
        contact info
    ==============================  --> */}
      <section className="contact-info py-0">
        <div className="container">
          <div className="row row-no-gutter boxes-wrapper">
            <div className="col-sm-12 col-md-4">
              <div className="contact-box">
                <div className="contact__icon mb-10" style={{margin: 'auto'}}>
                  <img src="../../assets/images/icons/ehr_00.png" alt="icon" />
                </div>
                <div className="contact__content">
                  <h2 className="contact__title">
                    {" "}
                    <a href="/resarch/home" className="contact__title">
                      National Digital Health Mission
                    </a>
                  </h2>
                  <p className="contact__desc">
                    The National Digital Health Mission (NDHM) is a digital healthcare initiative launched by the Government of India in 2020. The aim of the NDHM is to provide every citizen of India with a unique health identification number, called the Health ID, and to create a digital health ecosystem that connects all stakeholders in the healthcare system, including patients, healthcare providers, and insurance companies.
                    The NDHM aims to improve the delivery of healthcare services in India by providing a centralized platform for accessing various health-related information and services. This includes electronic health records, telemedicine, and other digital health services. The NDHM is being implemented through the development of the Unified Health Interface (UHI), which is a digital platform that provides a single point of access to various health services in India.
                    The NDHM is expected to improve the efficiency and effectiveness of the healthcare system in India, and ultimately lead to better health outcomes for individuals. It is also expected to help reduce the burden on the healthcare system by improving the quality and availability of healthcare services, and reducing the cost of healthcare for individuals and the government.
                  </p>
                </div>
                {/* <!-- /.contact__content  --> */}
              </div>
            </div>

            {/* <!-- /.col-md-4  --> */}
            <div className="col-sm-12 col-md-4">
              <div className="contact-box">
                <div className="contact__icon mb-10" style={{margin: 'auto'}}>
                  <img src="../../assets/images/icons/ehr_02.png" alt="icon" />
                </div>
                {/* <!-- /.contact__icon  --> */}
                <div className="contact__content">
                  <h2 className="contact__title">
                    {" "}
                    <a href="/doctor/home" className="contact__title">
                      Unified Health Interface
                    </a>
                  </h2>
                  <p className="contact__desc">
                    The Unified Health Interface (UHI) is a digital platform that aims to provide a single point of access to various health services in India. It is being developed by the Ministry of Health and Family Welfare (MoHFW) as part of the National Digital Health Mission (NDHM).
                    The UHI is intended to improve the delivery of healthcare services in India by providing a centralized platform for accessing various health-related information and services. It will allow individuals to access their health records, find and book appointments with healthcare providers, and access other health-related information and services.
                    The UHI will also provide healthcare providers with access to a range of tools and services, including electronic health records, telemedicine, and other digital health services. This will help to improve the efficiency and effectiveness of the healthcare system in India, and ultimately lead to better health outcomes for individuals.
                    The UHI is still in the development phase, and the MoHFW is working with various stakeholders, including healthcare providers, technology companies, and others, to ensure that it meets the needs of all users. It is expected to be fully operational in the near future.
                  </p>
                  {/*<a href="/doctor/appointments" className="btn btn__white btn__outlined btn__rounded">
                    <span>View Appointments</span>
                    <i className="icon-arrow-right"></i>
                  </a>*/}
                </div>
                {/* <!-- /.contact__content  --> */}
              </div>
              {/* <!-- /.contact-box  --> */}
            </div>
            {/* <!-- /.col-md-4  --> */}
            <div className="col-sm-12 col-md-4">
              <div className="contact-box">
                <div className="contact__icon mb-10" style={{margin: 'auto'}}>
                  <img src="../../assets/images/icons/ehr_03.png" alt="icon" />
                </div>
                {/* <!-- /.contact__icon  --> */}
                <div className="contact__content">
                  <h2 className="contact__title">
                    {" "}
                    <a href="/resarch/home" className="contact__title">
                      Health Data Standards
                    </a>
                  </h2>
                  <ul className="time__list list-unstyled mb-0">
                    <li>
                      Health data standardization and codification refers to the process of ensuring that health data is organized and structured in a consistent and standardized manner, using standardized codes and terminology. This allows for the accurate and efficient exchange and use of health data between different systems and stakeholders, including healthcare providers, insurance companies, and government agencies.
                      This is particularly important for electronic health records (EHRs) and other digital health systems, which rely on accurate and consistent data for the effective delivery of healthcare services. Standardization and codification of health data is an important part of the National Digital Health Mission (NDHM) in India.<br/>There are several standardization and codification systems in use in the healthcare industry e.g. International Classification of Diseases (ICD) being a standard for classifying diseases and health conditions, developed by the World Health Organization (WHO), Clinical Document Architecture (CDA) being a standard for exchanging electronic health records and other clinical documents between different systems and stakeholders, Systematized Nomenclature of Medicine (SNOMED) being a comprehensive standard for medical terminology system, LOINC (Logical Observation Identifiers Names and Codes) being a standard coding system for identifying and exchanging laboratory and clinical observations.
                    </li>
                  </ul>
                </div>
                {/* <!-- /.contact__content  --> */}
              </div>
            </div>
            {/* <!-- /.contact-box  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.contact-info  --> */}

      {/* <!-- ========================
      About Layout 2
    ===========================  --> */}
      <section className="about-layout2 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7 offset-lg-1">
              <div className="heading-layout2">
                <h3 className="heading__title mb-60">
                  Improving The Quality Of Your <br /> Life Through Better Healthcare.
                </h3>
              </div>
              {/* <!-- /heading  --> */}
            </div>
            {/* <!-- /.col-12  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-5">
              <div className="text-with-icon">
                <div className="text__icon">
                  <i className="icon-doctor"></i>
                </div>
                <div className="text__content">
                  <p className="heading__desc font-weight-bold color-secondary mb-30">
                    Our mission is to improvise the experience of all walks of healthcare professionals, general
                    populations and patients with best possible state-of-the-art quality of healthcare in a courteous,
                    respectful, and compassionate manner. We hope you will allow us to care for you and strive to be the
                    first and best choice for healthcare.
                  </p>
                  <a href="doctors-timetable.html" className="btn btn__secondary btn__rounded mb-70">
                    <span>Find A Doctor</span> <i className="icon-arrow-right"></i>
                  </a>
                </div>
              </div>
              {/* <!--<div className="video-banner-layout2 bg-overlay">
              <img src="../../assets/images/about/2.jpg" alt="about" className="w-100">
              <a className="video__btn video__btn-white popup-video" href="https://www.youtube.com/watch?v=efGa8QD8pU4">
                <div className="video__player">
                  <i className="fa fa-play"></i>
                </div>
                <span className="video__btn-title color-white">Watch A Video!</span>
              </a>
            </div>{/* <!-- /.video-banner  --> */}
            </div>
            {/* <!-- /.col-lg-6  --> */}
            <div className="col-sm-12 col-md-12 col-lg-7">
              <div className="about__text bg-white">
                <ul className="list-items list-unstyled">
                  <li>
                    We conduct a range of tests from our renowned and popular Lab Services (invassive/ non-invassive
                    whereever applicable) to help us work out why you're not feeling well and determine the right
                    treatment for you.
                  </li>
                  <li>
                    Our partner clinics and hospitals with expert doctors, nurses and allied health professionals manage
                    patients with a broad range of medical issues.
                  </li>
                  <li>
                    By virtue of an aggregator in healthcare services, we offer a wide range of care and support to our
                    patients, from diagnosis to treatment and rehabilitation.
                  </li>
                </ul>
              </div>
            </div>
            {/* <!-- /.col-lg-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.About Layout 2  --> */}

      {/* <!-- ========================
        Services Layout 1
    ===========================  --> */}
      <section className="services-layout1 services-carousel">
        <div className="bg-img">
          <img src="../../assets/images/backgrounds/2.jpg" alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="heading text-center mb-60">
                {/* <!--<h2 className="heading__subtitle">The Best Medical And General Health Care!</h2>
              <h3 className="heading__title">Providing Medical Care For The Sickest In Our Community.</h3> --> */}
                <h3 className="heading__title">Our Vision and Platform Roadmap</h3>
                <h2 className="heading__subtitle">
                  Providing everyday Healthcare and Assistance for the Masses in a Digital Framework
                </h2>
              </div>
              {/* <!-- /.heading  --> */}
              <div width="100%" className="row row-no-gutter boxes-wrapper">
                <p>
                  <img src="../../assets/images/Platform/roadmap.jpg" alt="background" />
                </p>
              </div>
            </div>
            {/* <!-- /.col-lg-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row">
            <div className="col-12">
              {/* <!--<div className="slick-carousel"
              data-slick='{"slidesToShow": 3, "slidesToScroll": 1, "autoplay": true, "arrows": false, "dots": true, "responsive": [ {"breakpoint": 992, "settings": {"slidesToShow": 2}}, {"breakpoint": 767, "settings": {"slidesToShow": 1}}, {"breakpoint": 480, "settings": {"slidesToShow": 1}}]}'>
              {/* <!-- service item #1   </div>--> */}
            </div>
            {/* <!-- /.col-12  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.Services Layout 1  --> */}

      {/* <!-- ========================
        Notses
    ===========================  --> */}
      <section className="notes border-top pt-60 pb-60">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="note font-weight-bold">
                <i className="far fa-file-alt color-primary"></i>
                <span>Delivering tomorrow’s health care for your family.</span>
                <a href="doctors-timetable.html" className="btn btn__link btn__secondary">
                  <span>View Doctors’ Timetable</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>
            </div>
            {/* <!-- /.col-sm-6  --> */}
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="info__meta d-flex flex-wrap justify-content-between align-items-center">
                <div className="testimonials__rating">
                  <div className="testimonials__rating-inner d-flex align-items-center">
                    <span className="total__rate">4.9</span>
                    <div>
                      <span className="overall__rate">Zocdoc Overall Rating</span>
                      <span>, based on 7541 reviews.</span>
                    </div>
                  </div>
                  {/* <!-- /.testimonials__rating-inner  --> */}
                </div>
                {/* <!-- /.testimonials__rating  --> */}
                <a href="appointment.html" className="btn btn__primary btn__rounded">
                  <span>Make Appointment</span> <i className="icon-arrow-right"></i>
                </a>
              </div>
              {/* <!-- /.info__meta  --> */}
            </div>
            {/* <!-- /.col-sm-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.notes  --> */}

      {/* <!-- ======================
    Features Layout 2
    =========================  --> */}
      <section className="features-layout2 pt-130 bg-overlay bg-overlay-primary">
        <div className="bg-img">
          <img src="../../assets/images/backgrounds/2.jpg" alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-8 offset-lg-1">
              <div className="heading__layout2 mb-50">
                <h3 className="heading__title color-white">
                  HealthWalk Has Touched The Lives Of millions of Patients & Providing Care for The Sickest In Our
                  Community in a completely new Digitized methodology and practices.
                </h3>
              </div>
            </div>
            {/* <!-- /col-lg-5  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row mb-100">
            <div className="col-sm-3 col-md-3 col-lg-1 offset-lg-5">
              <div className="heading__icon">
                <i className="icon-insurance"></i>
              </div>
            </div>
            {/* <!-- /.col-lg-5  --> */}
            <div className="col-sm-9 col-md-9 col-lg-6">
              <p className="heading__desc font-weight-bold color-white mb-30">
                HealthWalk has been ready to begin journey in India starting 2022, offering innovative solutions,
                specializing in medical services for treatments within a Cloud based digitized private infrastructure
                maintaining all Indian Regulations and Compliance standards. With over potentially 100 professionals
                actively participates in numerous initiatives aimed at creating sustainable change for patients
                assisting a journey from 'Sickcare' to 'Healthcare'!
              </p>
              <a href="#" className="btn btn__white btn__link">
                <i className="icon-arrow-right icon-filled"></i>
                <span>Our Core Business Initiatives</span>
              </a>
            </div>
            {/* <!-- /.col-lg-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row">
            {/* <!-- Feature item #1  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/1.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-heart"></i>
                  </div>
                  <h4 className="feature__title">Transformations in Healthcare</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #2  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/2.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-doctor"></i>
                  </div>
                  <h4 className="feature__title">Patients & Doctor's Community</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #3  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/3.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-ambulance"></i>
                  </div>
                  <h4 className="feature__title">Electronic Health Records</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #4  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/4.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-drugs"></i>
                  </div>
                  <h4 className="feature__title">Future Oriented Disruptive Diagonosis</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #5  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/5.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-first-aid-kit"></i>
                  </div>
                  <h4 className="feature__title">Remote & AI Based Monitoring</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #6  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/6.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-hospital"></i>
                  </div>
                  <h4 className="feature__title">Conversational Digital Assistants</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #7  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/7.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-expenses"></i>
                  </div>
                  <h4 className="feature__title">E-commerce for every need</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            {/* <!-- Feature item #8  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/8.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-bandage"></i>
                  </div>
                  <h4 className="feature__title">Therpeutic AR/VR/MR</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}

            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/9.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-stethoscope"></i>
                  </div>
                  <h4 className="feature__title">AI Assisted Predictions, recommendations</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/10.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-thermometer"></i>
                  </div>
                  <h4 className="feature__title">IoT & sensors Data Ingestions, Analysis resulting Trends</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/11.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-hospital"></i>
                  </div>
                  <h4 className="feature__title">Turning Information into Insights through advanced analytics</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="feature-item">
                <div className="feature__img">
                  <img src="../../assets/images/services/12.jpg" alt="service" loading="lazy" />
                </div>
                {/* <!-- /.feature__img  --> */}
                <div className="feature__content">
                  <div className="feature__icon">
                    <i className="icon-heart"></i>
                  </div>
                  <h4 className="feature__title">3D Printed Organs & Tools for impared or specially enabled</h4>
                </div>
                {/* <!-- /.feature__content  --> */}
                <a href="#" className="btn__link">
                  <i className="icon-arrow-right icon-outlined"></i>
                </a>
              </div>
              {/* <!-- /.feature-item  --> */}
            </div>
            {/* <!-- /.col-lg-3  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row">
            <div className="col-md-12 col-lg-6 offset-lg-3 text-center">
              <p className="font-weight-bold color-gray mb-0">
                We hope you will allow us to care for you and strive to be the first and best choice for healthcare.
                <a href="#" className="color-secondary">
                  <span>Contact Us For More Information</span> <i className="icon-arrow-right"></i>
                </a>
              </p>
            </div>
            {/* <!-- /.col-lg-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.Features Layout 2  --> */}

      {/* <!-- ======================
      Team Removed
    =========================  --> */}

      {/* <!-- ======================
     Work Process 
    =========================  --> */}
      <section className="work-process work-process-carousel pt-130 pb-0 bg-overlay bg-overlay-secondary">
        <div className="bg-img">
          <img src="../../assets/images/banners/1.jpg" alt="background" />
        </div>
        <div className="container">
          <div className="row heading-layout2">
            <div className="col-12">
              <h2 className="heading__subtitle color-primary">Caring For The Health Of You And Your Family.</h2>
            </div>
            {/* <!-- /.col-12  --> */}
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-5">
              <h3 className="heading__title color-white">
                We Provide a unique Patient 360 degree personalized experience and All Aspects Of Medical Practice For
                Your Whole Family!
              </h3>
            </div>
            {/* <!-- /.col-xl-5  --> */}
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 offset-xl-1">
              <p className="heading__desc font-weight-bold color-gray mb-40">
                We will be responsible and accountable to store and protect your Electronic Health Records (EHR) and
                associated data to enable you uniquely in registering a seamless journey from begining to end of your
                individual health. We will retain your unique access control of your own EHR round-the-clock and set
                privacy and sharing rules and settings of the same in time of need with any third party service
                providers (any progressive clinics, hospitals, doctors etc.) across the board after you register into
                our platform and would be able to succesfully authenticate yourselves.
              </p>
              <ul className="list-items list-items-layout2 list-items-light list-horizontal list-unstyled">
                <li>Preventive Care</li>
                <li>Health Treatments & Procedures</li>
                <li>Post Treatments Care</li>
                <li>Body Maintainance</li>
                <li>Remote Care & Tele-Medicines</li>
                <li>Online Board of Doctors</li>
              </ul>
            </div>
            {/* <!-- /.col-xl-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row">
            <div className="col-12">
              <div className="carousel-container mt-90">
                <div
                  className="slick-carousel"
                  data-slick='{"slidesToShow": 4, "slidesToScroll": 1, "infinite":false, "arrows": false, "dots": false, "responsive": [{"breakpoint": 1200, "settings": {"slidesToShow": 3}}, {"breakpoint": 992, "settings": {"slidesToShow": 2}}, {"breakpoint": 767, "settings": {"slidesToShow": 2}}, {"breakpoint": 480, "settings": {"slidesToShow": 1}}]}'
                >
                  {/* <!-- process item #1  --> */}
                  <div className="process-item">
                    <span className="process__number">01</span>
                    <div className="process__icon">
                      <i className="icon-health-report"></i>
                    </div>
                    {/* <!-- /.process__icon  --> */}
                    <h4 className="process__title">Fill In Our Medical Application</h4>
                    <p className="process__desc">
                      HealthWalk offers low-cost health coverage for adults with limited income, you can enroll.
                    </p>
                    <a href="#" className="btn btn__secondary btn__link">
                      <span>Doctors’ Timetable</span>
                      <i className="icon-arrow-right"></i>
                    </a>
                  </div>
                  {/* <!-- /.process-item  --> */}
                  {/* <!-- process-item #2  --> */}
                  <div className="process-item">
                    <span className="process__number">02</span>
                    <div className="process__icon">
                      <i className="icon-dna"></i>
                    </div>
                    {/* <!-- /.process__icon  --> */}
                    <h4 className="process__title">Review Your Family Medical History</h4>
                    <p className="process__desc">
                      Regular health exams can help find all the problems, also can find it early chances.
                    </p>
                    <a href="#" className="btn btn__secondary btn__link">
                      <span>Start A Check Up</span>
                      <i className="icon-arrow-right"></i>
                    </a>
                  </div>
                  {/* <!-- /.process-item  --> */}
                  {/* <!-- process-item #3  --> */}
                  <div className="process-item">
                    <span className="process__number">03</span>
                    <div className="process__icon">
                      <i className="icon-medicine"></i>
                    </div>
                    {/* <!-- /.process__icon  --> */}
                    <h4 className="process__title">Choose Between Our Care Programs</h4>
                    <p className="process__desc">
                      We have protocols to protect our patients while continuing to provide necessary care.
                    </p>
                    <a href="#" className="btn btn__secondary btn__link">
                      <span>Explore Programs</span>
                      <i className="icon-arrow-right"></i>
                    </a>
                  </div>
                  {/* <!-- /.process-item  --> */}
                  {/* <!-- process-item #4  --> */}
                  <div className="process-item">
                    <span className="process__number">04</span>
                    <div className="process__icon">
                      <i className="icon-stethoscope"></i>
                    </div>
                    {/* <!-- /.process__icon  --> */}
                    <h4 className="process__title">Introduce You To Highly Qualified Doctors</h4>
                    <p className="process__desc">
                      Our administration and support staff have exceptional skills and trained to assist you.{" "}
                    </p>
                    <a href="#" className="btn btn__secondary btn__link">
                      <span>Meet Our Doctors</span>
                      <i className="icon-arrow-right"></i>
                    </a>
                  </div>
                  {/* <!-- /.process-item  --> */}
                  {/* <!-- process-item #5  --> */}
                  <div className="process-item">
                    <span className="process__number">05</span>
                    <div className="process__icon">
                      <i className="icon-head"></i>
                    </div>
                    {/* <!-- /.process__icon  --> */}
                    <h4 className="process__title">Your custom Next process</h4>
                    <p className="process__desc">
                      Our administration and support staff have exceptional skills to assist you.
                    </p>
                    <a href="#" className="btn btn__secondary btn__link">
                      <span>Meet Our Doctors</span>
                      <i className="icon-arrow-right"></i>
                    </a>
                  </div>
                  {/* <!-- /.process-item  --> */}
                </div>
                {/* <!-- /.carousel  --> */}
              </div>
            </div>
            {/* <!-- /.col-12  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
        <div className="cta bg-light-blue">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-12 col-md-2 col-lg-2">
                <img src="../../assets/images/icons/alert2.png" alt="alert" />
              </div>
              {/* <!-- /.col-lg-2  --> */}
              <div className="col-sm-12 col-md-7 col-lg-7">
                <h4 className="cta__title">True Healthcare For Your Family!</h4>
                <p className="cta__desc">
                  Serve the community by improving the quality of life through better health. We have put protocols to
                  protect our patients and staff while continuing to provide medically necessary care.
                </p>
              </div>
              {/* <!-- /.col-lg-7  --> */}
              <div className="col-sm-12 col-md-3 col-lg-3">
                <a href="" className="btn btn__primary btn__secondary-style2 btn__rounded">
                  <span>Healthcare Programs</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>
              {/* <!-- /.col-lg-3  --> */}
            </div>
            {/* <!-- /.row  --> */}
          </div>
          {/* <!-- /.container  --> */}
        </div>
        {/* <!-- /.cta  --> */}
      </section>
      {/* <!-- /.Work Process  --> */}


    {/* 
      <section className="blog-grid pb-50">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
              <div className="heading text-center mb-40">
                <h3 className="heading__title">Leadership Team</h3>
                <h2 className="heading__subtitle">Human Led and AI Assisted digital proprietary platform</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="">
                    <img src="../../assets/images/about/abo_01.png" alt="post image" loading="lazy" />
                  </a>
                </div>
                <div className="post__body_doc">
                  <h4 className="post__title_doc">
                    <a href="#">DR. SUDDHASATTWA SEN</a>
                  </h4>
                  <p className="doc__designation">
                    Health Expert, Business Leader<br/>
                    &<br/>
                    <span>Brand Ambassador</span>
                  </p>

                  <p className="post__desc_doc mb-5">
                    Dr. Sen has 25+ years of expertise in Gastrointestinal Diseases
                    and Cancer Surgery treatments in abroad and India.
                  </p>
                  <p className="post__desc_doc mb-5">
                    He had played a role of Sr. Consultant and head of departments
                    across many hospitals including AMRI, Medica, Apollo
                    Gleneagles, Fortis Kolkata, Belle Vue Kolkata, CMRI, Woodlands,
                    EEDF & SASK.
                  </p>
                  <p className="post__desc_doc mb-5">
                    Dr. Sen has an elegant past of academic excellence.
                    MBBS (Gold medalist), MS (Gold medalist), DNB (All India Gold
                    medalist), MNAMS (IND), MRCS (UK), FICS (USA), DNB (SGE &
                    HPB), FMAS (AMASI), Fellow HPB & Liver Transplant (Sir
                    Gangaram, Apollo, Del), CC Lap Solid Organ Surgery (Ethicon), CC
                    Endohernia (Ethicon), OB. Fellow HPB & GIS (SGPGIMS, Lucknow
                    / GB Pant, Del).
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="">
                    <img src="../../assets/images/about/abo_02.png" alt="post image" loading="lazy" />
                  </a>
                </div>
                <div className="post__body_doc">
                  <h4 className="post__title_doc">
                    <a href="#">ANUP DAS</a>
                  </h4>
                  <p className="doc__designation">
                    Chief Strategist<br/>
                    &<br/>
                    <span>Executive Officer</span>
                  </p>

                  <p className="post__desc_doc mb-5">
                    Anup has over 25 years of experience on various
                    management and leadership functions including Practice
                    Management, Delivery Management, Product Development
                    across multiple platforms.
                  </p>
                  <p className="post__desc_doc mb-5">
                    Anup is Chief Strategy Officer and Head of India Business
                    for Exavalu, a leading consulting and advisory firm for niche
                    industries. He has also led Salesforce Practice for Cognizant
                    to build a billion dollar run rate practice with his leadership
                    on Strategy, P&L, delivery, Centre of Excellence, solution
                    and IP Development.<br/>

                    As a veteran consultant, Anup has guided multiple Fortune
                    500 companies in Life Sciences, Healthcare and Insurance in
                    their digital transformation.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="">
                    <img src="../../assets/images/about/abo_03.png" alt="post image" loading="lazy" />
                  </a>
                </div>
                <div className="post__body_doc">
                  <h4 className="post__title_doc">
                    <a className="text-uppercase" href="#">Animesh Banerjee</a>
                  </h4>
                  <p className="doc__designation">
                    Cross-Cloud<br/>
                    &<br/>
                    <span>Security Architect</span>
                  </p>

                  <p className="post__desc_doc mb-5">
                    Animesh has over 18+ years of experience as It Cross cloud architect, Board Director, Delivery Head & India Head of Datacolada and Salesforce Technology Evangelist with 24 Salesforce, 6 Copado and 2 Microsoft Certifications, who has served in varied roles of Presales Lead (UKIEMEA), COE India Lead, Chief Architect & Program Manager involving technical solution design, consulting, delivery management, customer management, implementation of large scale projects in different business domains like CRM, Healthcare, Education, Telecom and BFS.
                  </p>
                  <p className="post__desc_doc mb-5">
                    Extensively worked on varied technologies and cloud platforms creating enterprise solutions and customer facing products.
                  </p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>

      <section className="blog-grid pb-50 bg-light-blue">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
              <div className="heading text-center mb-40">
                <h3 className="heading__title text-white">HlthTek Optimus Advisors</h3>
                <h2 className="heading__subtitle text-white">Human Led and AI Assisted digital proprietary platform</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="">
                    <img src="../../assets/images/about/abo_04.png" alt="post image" loading="lazy" />
                  </a>
                </div>
                <div className="post__body_doc">
                  <h4 className="post__title_doc">
                    <a href="#" className="text-white">DR. RAJIV KUMAR KAR</a>
                  </h4>
                  <p className="doc__designation">
                    Assistant Professor of JBM School of Health Sciences and Technology,<br/>
                    Associate Faculty of Centre for<br/> Nanotechnology, IIT Guwahati, India
                    <span>Rabindranath Tagore International Institute Of
                    Cardiac Sciences</span><br/>
                    Scientist (Technische Universität Berlin · Full-time)
                  </p>

                  <p className="post__desc_doc mb-5 text-white">
                    An experienced, competent and confident professional, who has a good understanding of biotechnology, nanotechnology, and principles of diagnostic tool development. Is a determined research professional and would like to play a key role in educational cum research settings.<br/>
                    He completed his post doctoral research from The Hebrew University of Jerusalem · Full-time. Before that he completed his PhD from Bose Institute, Kolkata, India
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="">
                    <img src="../../assets/images/about/abo_05.png" alt="post image" loading="lazy" />
                  </a>
                </div>
                <div className="post__body_doc">
                  <h4 className="post__title_doc">
                    <a href="#" className="text-white">DR. DIPANKAR BONDYOPADHYAY</a>
                  </h4>
                  <p className="doc__designation">
                    Head, Centre for Nanotechnology, IIT Guwahati,<br/>
                    Assam. India<br/>
                    [June 2018 – Till date]<br/>
                    <span>Professor, IIT Guwahati<br/> [October 2018 – Till Date]</span>
                  </p>

                  <p className="post__desc_doc mb-5 text-white">
                    Dipankar is an IIT, Kanpur M. Tech Grad who has
                    published 30+ publications in many international
                    forums and magazines in his academic and research
                    career before taking charge of Centre for
                    Nanotechnology, IITG
                  </p>
                  <p className="post__desc_doc mb-5 text-white">
                    <b>Research Interest(s) :</b> Colloid and Interfacial
                    Phenomena, Computational Fluid Dynamics, Micro and
                    Nano fluidics, Complex Flow and Fluids.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="">
                    <img src="../../assets/images/about/abo_06.png" alt="post image" loading="lazy" />
                  </a>
                </div>
                <div className="post__body_doc">
                  <h4 className="post__title_doc">
                    <a href="#" className="text-white">PROF. SUPTENDRA NATH SARBADHIKARI</a>
                  </h4>
                  <p className="doc__designation">
                    Expert-HMIS in Uttarakhand Health System Deveppment Project (UKHSDP), Dehradun, India<br/>
                    <span>MBBS, PhD (IIT, BHU, Varanasi)</span>
                  </p>

                  <p className="post__desc_doc mb-5 text-white">
                    Prof. Sarbadhikari is having more than 30 years of experience as Health Informatics Educationist specializing on Digital Health Standards, with a basic training as a medical doctor (University of Calcutta) and PhD in Biomedical Engineering (IIT, BHU, Varanasi). He was a Fellow of the IAHSI and appeared in Roster for Digital Health of the WHO [2019-2022]. Formerly he was Dean and Professor (Health Informatics) at IIHMR, Delhi. He also led a Project of the Ministry of Health & Family Welfare, GOI and also served as Project Director for the Centre for Health Informatics of the National Health Portal (NHP)
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 */}


      {/* <!-- ========================= 
      Testimonials Removed
      =========================   --> */}

      {/* <!-- ========================
       gallery removed
      ===========================  --> */}

      {/* <!-- ==========================
        contact layout 3
    ===========================  --> */}
      <section className="contact-layout3 bg-overlay bg-overlay-primary-gradient pb-60">
        <div className="bg-img">
          <img src="../../assets/images/banners/3.jpg" alt="banner" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7">
              <div className="contact-panel mb-50">
                <form className="contact-panel__form" method="post" action="assets/php/contact.php" id="contactForm">
                  <div className="row">
                    <div className="col-sm-12">
                      <h4 className="contact-panel__title">Book An Appointment</h4>
                      <p className="contact-panel__desc mb-30">
                        Please feel welcome to contact our friendly reception staff with any general or medical enquiry.
                        Our doctors will receive or return any urgent calls.
                      </p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <i className="icon-widget form-group-icon"></i>
                        <select className="form-control">
                          <option value="0">Choose Clinic</option>
                          <option value="1">Pathology Clinic</option>
                          <option value="2">Dermatology Clinic</option>
                        </select>
                      </div>
                    </div>
                    {/* <!-- /.col-lg-6  --> */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <i className="icon-user form-group-icon"></i>
                        <select className="form-control">
                          <option value="0">Choose Doctor</option>
                          <option value="1">Rakshit Pulluguartha</option>
                          <option value="2">Indrani Bagchi</option>
                        </select>
                      </div>
                    </div>
                    {/* <!-- /.col-lg-6  --> */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <i className="icon-news form-group-icon"></i>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Name"
                          id="contact-name"
                          name="contact-name"
                          required
                        />
                      </div>
                    </div>
                    {/* <!-- /.col-lg-6  --> */}
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <i className="icon-email form-group-icon"></i>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          id="contact-email"
                          name="contact-email"
                          required
                        />
                      </div>
                    </div>
                    {/* <!-- /.col-lg-6  --> */}
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <div className="form-group">
                        <i className="icon-phone form-group-icon"></i>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Phone"
                          id="contact-Phone"
                          name="contact-phone"
                          required
                        />
                      </div>
                    </div>
                    {/* <!-- /.col-lg-4  --> */}
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <div className="form-group form-group-date">
                        <i className="icon-calendar form-group-icon"></i>
                        <input type="date" className="form-control" id="contact-date" name="contact-date" required />
                      </div>
                    </div>
                    {/* <!-- /.col-lg-4  --> */}
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <div className="form-group form-group-date">
                        <i className="icon-clock form-group-icon"></i>
                        <input type="time" className="form-control" id="contact-time" name="contact-time" required />
                      </div>
                    </div>
                    {/* <!-- /.col-lg-4  --> */}
                    <div className="col-12">
                      <button type="submit" className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10">
                        <span>Book Appointment</span> <i className="icon-arrow-right"></i>
                      </button>
                      <div className="contact-result"></div>
                    </div>
                    {/* <!-- /.col-lg-12  --> */}
                  </div>
                  {/* <!-- /.row  --> */}
                </form>
              </div>
            </div>
            {/* <!-- /.col-lg-7  --> */}
            <div className="col-sm-12 col-md-12 col-lg-5">
              <div className="heading heading-light mb-30">
                <h3 className="heading__title mb-30">Helping Patients From Around the Globe!!</h3>
                <p className="heading__desc">
                  Our staff strives to make each interaction with patients clear, concise, and inviting. Support the
                  important work of Medicsh Hospital by making a much-needed donation today.
                </p>
              </div>
              <div className="d-flex align-items-center">
                <a href="contact-us.html" className="btn btn__white btn__rounded mr-30">
                  <i className="fas fa-heart"></i> <span>Make A Gift</span>
                </a>
                <a
                  className="video__btn video__btn-white popup-video"
                  href="https://www.youtube.com/watch?v=nrJtHemSPW4"
                >
                  <div className="video__player">
                    <i className="fa fa-play"></i>
                  </div>
                  <span className="video__btn-title color-white">Play Video</span>
                </a>
              </div>
              <div className="text__block">
                <p className="text__block-desc color-white font-weight-bold">
                  We provide a comprehensive range of plans for families and individuals at every stage of life, with
                  annual limits ranging from £1.5m to unlimited.
                </p>
                <div className="sinature color-white">
                  <span className="font-weight-bold">Martin Qube</span>
                  <span>, HealthWalk Manager</span>
                </div>
              </div>
              {/* <!-- /.text__block  --> */}
            </div>
            {/* <!-- /.col-lg-5  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.contact layout 3  --> */}

      {/* <!-- ======================
      Blog Grid
    =========================  --> */}
      <section className="blog-grid pb-50">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
              <div className="heading text-center mb-40">
                <h2 className="heading__subtitle">Resource Library</h2>
                <h3 className="heading__title">Recent Articles</h3>
              </div>
              {/* <!-- /.heading  --> */}
            </div>
            {/* <!-- /.col-lg-6  --> */}
          </div>
          {/* <!-- /.row  --> */}
          <div className="row">
            {/* <!-- Post Item #1  --> */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="blog-single-post.html">
                    <img src="../../assets/images/blog/sad-day.jpeg" alt="post image" loading="lazy" />
                  </a>
                </div>
                {/* <!-- /.post__img  --> */}
                <div className="post__body">
                  <div className="post__meta-cat">
                    <a href="#">Mental Health</a>
                  </div>
                  {/* <!-- /.blog-meta-cat  --> */}
                  <div className="post__meta d-flex">
                    <span className="post__meta-date">Jan 30, 2021</span>
                    <a className="post__meta-author" href="#">
                      Robert Perrera
                    </a>
                  </div>
                  <h4 className="post__title">
                    <a href="#">6 Tips to Protect Your Mental Health When You’re Sick</a>
                  </h4>

                  <p className="post__desc">
                    It’s normal to feel anxiety, worry and grief any time you’re diagnosed with a condition that’s
                    certainly true if you test positive for COVID-19, or are presumed to be positive...
                  </p>
                  <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                    <span>Read More</span>
                    <i className="icon-arrow-right"></i>
                  </a>
                </div>
                {/* <!-- /.post__body  --> */}
              </div>
              {/* <!-- /.post-item  --> */}
            </div>
            {/* <!-- /.col-lg-4  --> */}
            {/* <!-- Post Item #2  --> */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="blog-single-post.html">
                    <img src="../../assets/images/blog/Face-mask.jpeg" alt="post image" loading="lazy" />
                  </a>
                </div>
                {/* <!-- /.post__img  --> */}
                <div className="post__body">
                  <div className="post__meta-cat">
                    <a href="#">Infectious</a>
                    <a href="#">Tips</a>
                  </div>
                  {/* <!-- /.blog-meta-cat  --> */}
                  <div className="post__meta d-flex">
                    <span className="post__meta-date">Jun 30, 2021</span>
                    <a className="post__meta-author" href="#">
                      Smriti Sengupta
                    </a>
                  </div>
                  <h4 className="post__title">
                    <a href="#">Unsure About Wearing a Face Mask? Here’s How and Why</a>
                  </h4>
                  <p className="post__desc">
                    That means that you should still be following any shelter-in-place orders in your community. But
                    when you’re venturing out to the grocery store, pharmacy or hospital..
                  </p>
                  <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                    <span>Read More</span>
                    <i className="icon-arrow-right"></i>
                  </a>
                </div>
                {/* <!-- /.post__body  --> */}
              </div>
              {/* <!-- /.post-item  --> */}
            </div>
            {/* <!-- /.col-lg-4  --> */}
            {/* <!-- Post Item #3  --> */}
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="post-item">
                <div className="post__img">
                  <a href="blog-single-post.html">
                    <img src="../../assets/images/blog/Eating-healthyWFH.jpg" alt="post image" loading="lazy" />
                  </a>
                </div>
                {/* <!-- /.post__img  --> */}
                <div className="post__body">
                  <div className="post__meta-cat">
                    <a href="#">Life Style</a>
                    <a href="#">Nutrition</a>
                  </div>
                  {/* <!-- /.blog-meta-cat  --> */}
                  <div className="post__meta d-flex">
                    <span className="post__meta-date">Feb 28, 2021</span>
                    <a className="post__meta-author" href="#">
                      Vasudeva Chowhan
                    </a>
                  </div>
                  <h4 className="post__title">
                    <a href="#">Tips for Eating Healthy When You’re Working From Home </a>
                  </h4>

                  <p className="post__desc">
                    It’s normal to feel anxiety, worry and grief any time you’re diagnosed with a condition that’s
                    certainly true if you test positive for COVID-19, or are presumed to be positive...
                  </p>
                  <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                    <span>Read More</span>
                    <i className="icon-arrow-right"></i>
                  </a>
                </div>
                {/* <!-- /.post__body  --> */}
              </div>
              {/* <!-- /.post-item  --> */}
            </div>
            {/* <!-- /.col-lg-4  --> */}
          </div>
          {/* <!-- /.row  --> */}
        </div>
        {/* <!-- /.container  --> */}
      </section>
      {/* <!-- /.blog Grid  --> */}

      {/* <!-- ========================
      Footer
    ==========================  --> */}
      <footer className="footer">
        <div className="footer-primary">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-3">
                <div className="footer-widget-about">
                  <img
                    src={NavLogoFooter}
                    alt="logo"
                    className="mb-30 logo-img"
                    width="135px"
                    height="76px"
                  />
                  <p className="color-gray">
                    Our goal is to deliver quality of care in a courteous, respectful, and compassionate manner. We hope
                    you will allow us to care for you and strive to be the first and best choice for your family
                    healthcare.
                  </p>
                  <a href="appointment.html" className="btn btn__primary btn__primary-style2 btn__link">
                    <span>Make Appointment</span> <i className="icon-arrow-right"></i>
                  </a>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-xl-2  --> */}
              <div className="col-sm-6 col-md-6 col-lg-2 offset-lg-1">
                <div className="footer-widget-nav">
                  <h6 className="footer-widget__title">Our Services</h6>
                  <nav>
                    <ul className="list-unstyled">
                      <li>
                        <a href="#">For Doctors</a>
                      </li>
                      <li>
                        {" "}
                        <a href="/doctor/home" className="home-button">
                          Physicians
                        </a>
                      </li>
                      <li>
                        <a href="#">For Patients</a>
                      </li>
                      <li>
                        <a href="#">For Laboratories</a>
                      </li>
                      <li>
                        <a href="#">For Researchers</a>
                      </li>
                      <li>
                        <a href="#">For Trainers</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-lg-2  --> */}
              <div className="col-sm-6 col-md-6 col-lg-2">
                <div className="footer-widget-nav">
                  <h6 className="footer-widget__title">Links</h6>
                  <nav>
                    <ul className="list-unstyled">
                      <li>
                        <a href="#">About Us</a>
                      </li>
                      <li>
                        <a href="#">Our CLinic</a>
                      </li>
                      <li>
                        <a href="#">Our Doctors</a>
                      </li>
                      <li>
                        <a href="#">News & Media</a>
                      </li>
                      <li>
                        <a href="#">Appointments</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-lg-2  --> */}
              <div className="col-sm-12 col-md-6 col-lg-4">
                <div className="footer-widget-contact">
                  <h6 className="footer-widget__title color-heading">Quick Contacts</h6>
                  <ul className="contact-list list-unstyled">
                    <li>If you have any questions or need help, feel free to contact with our team.</li>
                    <li>
                      <a href="tel:+91-9073940606" className="phone__number">
                        <i className="icon-phone"></i> <span>+91-9073940606</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:+91-9073940606" className="phone__number">
                        <i className="icon-email"></i> <span>contactus@hlthtek.com</span>
                      </a>
                    </li>
                    <li className="color-body">Kolkata, West Bengal, India.</li>
                  </ul>
                  <div className="d-flex align-items-center">
                    <a href="#" className="btn btn__primary btn__link mr-30">
                      <i className="icon-arrow-right"></i> <span>Get Directions</span>
                    </a>
                    <ul className="social-icons list-unstyled mb-0">
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                    </ul>
                    {/* <!-- /.social-icons  --> */}
                  </div>
                </div>
                {/* <!-- /.footer-widget__content  --> */}
              </div>
              {/* <!-- /.col-lg-2  --> */}
            </div>
            {/* <!-- /.row  --> */}
          </div>
          {/* <!-- /.container  --> */}
        </div>
        {/* <!-- /.footer-primary  --> */}
        <div className="footer-secondary">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <span className="fz-14">&copy; 2022 HlthTek Optimus Pvt. Ltd., All Rights Reserved.</span>
                
              </div>
              {/* <!-- /.col-lg-6  --> */}
              <div className="col-sm-12 col-md-6 col-lg-6">
                <nav>
                  <ul className="list-unstyled footer__copyright-links d-flex flex-wrap justify-content-end mb-0">
                    <li>
                      <a href="#">Terms & Conditions</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="#">Cookies</a>
                    </li>
                    <li>V2-2021-10-03 1527</li>
                  </ul>
                </nav>
              </div>
              {/* <!-- /.col-lg-6  --> */}
            </div>
            {/* <!-- /.row  --> */}
          </div>
          {/* <!-- /.container  --> */}
        </div>
        {/* <!-- /.footer-secondary  --> */}
      </footer>
      {/* <!-- /.Footer  --> */}
      <button id="scrollTopBtn">
        <i className="fas fa-long-arrow-alt-up"></i>
      </button>

      <Helmet>
        {/* <script src="/assets/js/jquery-3.5.1.min.js"></script> */}
        <script src="/assets/js/plugins.js"></script>
        <script src="/assets/js/main.js"></script>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"
        />
        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css" />

        <link href="/assets/images/logo/logo-light-small.png" rel="icon" />
      </Helmet>

      {/* <!-- /.wrapper  --> */}
    </div>
  );
}
export default Home;
